// extracted by mini-css-extract-plugin
export var footer = "PartnerReviewCard-module--footer--71086";
export var link = "PartnerReviewCard-module--link--eef03";
export var root = "PartnerReviewCard-module--root--25740";
export var title = "PartnerReviewCard-module--title--4d810";